import { scanPackSize, scanTotal } from '@/lib/scanQuantity';

export const scanGroupKey = item => `${item.art_id}:${item.variant_combo_key || item.variant_code || 'master'}`;
export const scanNewestFirst = items => [...items].sort((a, b) => (Number(b.last_scan_at) || 0) - (Number(a.last_scan_at) || 0));

export function addConfirmedScanQuantity(item, quantity, unit) {
  const amount = Number(quantity), size = scanPackSize(item);
  if (!Number.isSafeInteger(amount) || amount < 1 || !['pieces', 'packs'].includes(unit)) return null;
  const asUnits = unit === 'packs' || size === 1;
  const next = { ...item,
    aantal: Number(item.aantal) + (asUnits ? amount : 0),
    stuks_correctie: scanTotal(item) - Number(item.aantal) * size + (asUnits ? 0 : amount),
    last_scan_at: Date.now(),
  };
  return (item.cash_edit ? Number.isFinite(scanTotal(next)) && scanTotal(next) <= Number.MAX_SAFE_INTEGER : Number.isSafeInteger(scanTotal(next))) && scanTotal(next) > 0 ? next : null;
}

export function makeScanItem(art, variant = null, scannedEan = '') {
  const eenheid = art.eenheid || 'st';
  const packSize = Number(variant?.pack_grootte || art.pack_grootte) || 0;
  const size = eenheid === 'pack' && packSize > 0 ? packSize : (Number(variant?.eenheid_aantal || art.eenheid_aantal) || 0);
  const item = {
    _key: `${art.id}:${variant?.combo_key || scannedEan || art.ean || art.art_code || ''}`,
    art_id: art.id, art_code: art.art_code || '', omschrijving: art.omschrijving || '',
    ean: variant?.ean || scannedEan || art.ean || '',
    prijs: Number(variant?.prijs_override ?? Object.values(art.prijzen || {})[0] ?? 0),
    prijs_per_stuk: (art.prijs_basis || '').toLowerCase() === 'per_stuk' || (eenheid === 'pack' && art.prijs_basis !== 'pack'),
    variant_code: variant?.art_code || variant?.code || variant?.combo_key || '',
    variant_combo_key: variant?.combo_key || variant?.art_code || variant?.code || '',
    variant_label: variant?.combo ? Object.values(variant.combo).join(' · ') : '', variant_combo: variant?.combo || null,
    aantal: 1, korting: 0, btw: art.btw ?? 21, eenheid, eenheid_aantal: size,
    artikel_pack_grootte: size || 1, eenheid_label: eenheid === 'pack' && packSize > 0 ? 'st' : (variant?.eenheid_label ?? art.eenheid_label ?? '').trim(),
    stuks_effectief: size || 1, stuks_correctie: 0, voorraad: variant?.voorraad ?? art.voorraad ?? null, last_scan_at: Date.now(),
  };
  return { ...item, scan_group_key: scanGroupKey(item) };
}

export function emptyScanItem() {
  return { _key: `regel-${crypto.randomUUID()}`, art_id: '', art_code: '', omschrijving: '', ean: '',
    aantal: 1, korting: 0, btw: 21, prijs: 0, prijs_per_stuk: true, eenheid: 'st', eenheid_aantal: 1,
    artikel_pack_grootte: 1, stuks_effectief: 1, stuks_correctie: 0, last_scan_at: Date.now() };
}

export function replaceScanArticle(previous, art, variant) {
  const next = makeScanItem(art, variant);
  const previousTotal = scanTotal(previous);
  const count = Number(previous.aantal) || 1;
  return { ...next, _key: previous._key, aantal: count, korting: previous.korting || 0, korting_mode: previous.korting_mode || 'percent',
    ...(previous.btw_handmatig ? { btw: previous.btw, btw_handmatig: true } : {}),
    stuks_correctie: previousTotal < 0 ? previousTotal - count * scanPackSize(next) : 0 };
}